import { ACTIONS, FIELDS } from './constants';
import { INITIAL_STATE } from './initial-state';

export default function (state = INITIAL_STATE, { payload, type }) {
  switch (type) {
    case ACTIONS.SET_ERROR:
      return { ...state, [FIELDS.ERROR]: payload };
    case ACTIONS.SET_LOADING:
      return { ...state, [FIELDS.LOADING]: payload };
    case ACTIONS.SET_REFERENCE_BOOKS:
      return { ...state, ...payload };
    default:
      return state;
  }
}
